import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs'
import { environment } from '../environments/environment';

export interface AppConfig {

    apiUrl: string
    apiSearch: string
    apiOcr: string
    managerUrl: string
    documentationUrl: string
    ssoStatus : boolean
    ssoUrl: string
    realm: string
    clientId: string
    execEnv?: string
    /** Optionnel : si absent, Keycloak retombe sur l'URL courante. */
    redirectUri?: string
}

@Injectable({
  providedIn: 'root'
})

export class ConfigService {
  private readonly configUrl = '/' + environment.configFile;
  private config?: AppConfig;
  private env=environment;

constructor(private http: HttpClient) {}

  loadConfig(): Observable<AppConfig> {
    if(this.env.production){
      return this.http.get<AppConfig>(this.configUrl).pipe(
    tap((cfg) => {
      this.config = {
        ...cfg,
        execEnv: cfg.execEnv || 'prod'
      };
    })
  );
    } else {

      const configuration = this.http.get<AppConfig>(this.configUrl).pipe(
        tap((cfg) => (this.config = cfg))
      );
      return configuration

    }

  }

  getConfig(): AppConfig {
    if (!this.config) {
      throw new Error('Config not loaded yet. Call loadConfig() first.');
    }
    return this.config;
  }

  setConfig(config: AppConfig): void {
    this.config = config;
  }

  getApiBaseUrl(): string {
    const base = this.getConfig().apiUrl;
    return base.replace(/\/$/, '');
  }

  getApiBaseOcr(): string {
    const base = this.getConfig().apiOcr;
    return base.replace(/\/$/, '');
  }

  getApiBaseSearch(): string {
    const base = this.getConfig().apiSearch;
    return base.replace(/\/$/, '');
  }

  getExecEnv(): string {
    const execEnv = this.getConfig().execEnv || 'prod';
    return execEnv.replace(/\/$/, '');
  }

}